export enum ConfigActionType {
  SET_IS_SERVER = '@@config/SET_IS_SERVER',
}
